import { all, call, put, select, takeEvery } from "redux-saga/effects";
import { getDataFromRDS, getJwtToken } from "api";
import { ENDPOINT, PICTREE } from "../../constants";
import { setSaitamaOverview } from "actions";
import { SAITAMA_SEASON } from "reducers/pictree/pictreeSaitamaReducer";
import {
  buildSaitamaOverview,
  buildSaitamaQueries,
  toSaitamaUtcBounds,
  normalizeRows,
} from "helper/pictreeSaitamaPhotoShoot";

const selectedSeason = state => state.pictreeSaitama.selectedSeason;
const dateRange = state => state.pictreeSaitama.dateRange;
const chartSize = state => state.pictreeSaitama.chartSize;

export const SAITAMA_QUERY_ENDPOINT = ENDPOINT.GET_DATA_SXI_DENCHU;

export function* getSaitamaOverviewData() {
  try {
    const token = yield call(getJwtToken);
    const season = (yield select(selectedSeason))[0] || SAITAMA_SEASON;
    const range = yield select(dateRange);
    const grain = yield select(chartSize);
    const bounds = toSaitamaUtcBounds(range, season);
    const queries = buildSaitamaQueries({ seasonId: season.seasonId, ...bounds, grain });
    const keys = ["kpi01", "kpi02", "kpi03", "kpi05", "kpi06Denominator", "chartAssets", "chartPhotographers"];
    const results = yield all(keys.map(key => call(getDataFromRDS, queries[key], SAITAMA_QUERY_ENDPOINT, token)));
    const responses = keys.reduce((acc, key, index) => {
      acc[key] = normalizeRows(results[index]);
      return acc;
    }, {});
    yield put(setSaitamaOverview(buildSaitamaOverview({ responses, grain, dateRange: range })));
  } catch (error) {
    yield put(setSaitamaOverview({ status: "error", error: error.message || "Saitama data request failed" }));
  }
}

export default function* watchSaitama() {
  yield takeEvery(PICTREE.GET_SAITAMA_OVERVIEW, getSaitamaOverviewData);
}
